import { financeAnalyticsUrl } from "../../const";
import CommonMetabaseDashboard from "../../components/mis/metabase-dashboard/CommonMetabaseDashboard";

const FinanceAnalytics = () => {
  return <CommonMetabaseDashboard url={financeAnalyticsUrl} />;
};

export default FinanceAnalytics;
